module.exports = __webpack_public_path__ + "128446f1f425b99af30ffa75583f759b.svg";